module.exports = __webpack_public_path__ + "img/pethouse51.c01fbfaf.jpg";